export const MAX_TAGS = 20
export const MIN_TERM_LENGTH = 2
